import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, Observable, of } from 'rxjs';
import { ApiResponse, APP_CONFIG, ModelRepository, RayModel, TemplateModelViewModel } from '../core';
import { BaseService } from './base.service';
import { CaseService } from './case.service';


/**
* This service handles the ray analysis model.
*/
@Injectable({ providedIn: 'root' })
export class ModelService extends BaseService {

	private readonly config = inject(APP_CONFIG);
	private readonly caseSrv = inject(CaseService);
	private readonly modelRepo = inject(ModelRepository);

	private readonly _isReadOnly = toSignal(this.caseSrv.isReadOnly());


	/**
	* Save current model.
	*/
	persistModel(caseId: string, userGuid: string): Observable<void> {
		if (!this._isReadOnly()) {
			const model = (globalThis as any).main._saveHandler.getUpdatedData();
			const templateModel: TemplateModelViewModel = {
				version: this.config.fitboneModelVersion,
				caseId: caseId,
				userGuid: userGuid,
				model
			};
			return this.modelRepo.saveModel(templateModel).pipe(map((res: ApiResponse<void>) => this.handleApiResponse(res)));
		}
		return of();
	}

	/**
	* Restore current Ray model.
	*/
	restoreRayModel(caseId: string, userGuid: string): Observable<RayModel> {
		return this.modelRepo.getRayModel(caseId, userGuid).pipe(
			map((res: ApiResponse<RayModel>) => this.handleApiResponse(res))
		);
	}

	/**
	 * Restore current Template model.
	 * @param {string} caseId
	 * @param {string} userGuid
	 */
	restoreTemplateModel(caseId: string, userGuid: string): Observable<TemplateModelViewModel> {
		return this.modelRepo.getTemplateModel(caseId, userGuid).pipe(
			map((res: ApiResponse<TemplateModelViewModel>) => this.handleApiResponse(res))
		);
	}

}
